// extracted by mini-css-extract-plugin
module.exports = {"noWorkoutsFound":"NoResultsBanner_noWorkoutsFound__3Wpvb","text":"NoResultsBanner_text__1bsgQ"};